import { ECountry } from './countries';

export const COUNTRY_PREFIXES: Record<ECountry, string> = {
  [ECountry.ES]: '+34',
  [ECountry.AR]: '+54',
  [ECountry.AD]: '+376',
  [ECountry.BO]: '+591',
  [ECountry.BR]: '+55',
  [ECountry.CL]: '+56',
  [ECountry.CO]: '+57',
  [ECountry.CR]: '+506',
  [ECountry.CU]: '+53',
  [ECountry.DO]: '+1',
  [ECountry.EC]: '+593',
  [ECountry.US]: '+1',
  [ECountry.FR]: '+33',
  [ECountry.GF]: '+594',
  [ECountry.GT]: '+502',
  [ECountry.HT]: '+509',
  [ECountry.HN]: '+504',
  [ECountry.IN]: '+91',
  [ECountry.JM]: '+1',
  [ECountry.MX]: '+52',
  [ECountry.NI]: '+505',
  [ECountry.PA]: '+507',
  [ECountry.PY]: '+595',
  [ECountry.PE]: '+51',
  [ECountry.PR]: '+1',
  [ECountry.PT]: '+351',
  [ECountry.RU]: '+7',
  [ECountry.SR]: '+597',
  [ECountry.SV]: '+503',
  [ECountry.UY]: '+598',
  [ECountry.VE]: '+58',
  [ECountry.MA]: '+212',
  [ECountry.GB]: '+44',
  [ECountry.RO]: '+40'
};

export const getCountryPrefix = (country: ECountry): string => {
  return COUNTRY_PREFIXES[country] || '+34';
};
